import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useEditableField } from '../../../hooks/use-editable-field';
import { Delivery } from './delivery';
import { useClientsByChannel } from '../../../hooks/use-clients';
import { DeliveryOptions } from './types';
import { canUseSmsChannel } from '../../../utils/delivery-channels';
import { useSession } from '../../../../../../infra/session';
export var DeliveryContainer = function () {
    var session = useSession().data;
    var _a = useEditableField('sendSms'), sendSmsField = _a.field, setSendSmsValue = _a.setValue;
    var _b = useEditableField('sendEmail'), sendEmailField = _b.field, setSendEmailValue = _b.setValue;
    var _c = useEditableField('sendPush'), sendPushField = _c.field, setSendPushValue = _c.setValue;
    var _d = useEditableField('usesCustomDeliveryChannels'), customDeliveryChannelsField = _d.field, setCustomDeliveryChannelsValue = _d.setValue;
    var smsChannelEnabled = canUseSmsChannel({ session: session });
    var _e = useState(false), showDetails = _e[0], setShowDetails = _e[1];
    var _f = useState(false), showNoSmsModal = _f[0], setShowNoSmsModal = _f[1];
    var preventAllChannelsUnmarked = function () {
        var channels = [sendSmsField.value && smsChannelEnabled, sendEmailField.value, sendPushField.value];
        if (channels.filter(function (channel) { return !!channel; }).length === 1) {
            return true;
        }
        return false;
    };
    var handleChannelChange = function (value, setValue) {
        if (!value && preventAllChannelsUnmarked())
            return;
        setValue(value);
    };
    var selectedDeliveryType = (customDeliveryChannelsField === null || customDeliveryChannelsField === void 0 ? void 0 : customDeliveryChannelsField.value)
        ? DeliveryOptions.CUSTOM
        : DeliveryOptions.ALL_CHANNELS;
    var _g = useClientsByChannel(), clients = _g.clients, isLoading = _g.isLoading;
    return (_jsx(Delivery, { selectedDeliveryType: selectedDeliveryType, sendSms: sendSmsField, sendEmail: sendEmailField, sendPush: sendPushField, onSendSmsChange: function (e) { return handleChannelChange(e, setSendSmsValue); }, onSendEmailChange: function (e) { return handleChannelChange(e, setSendEmailValue); }, onSendPushChange: function (e) { return handleChannelChange(e, setSendPushValue); }, customDeliveryChannels: customDeliveryChannelsField, onCustomDeliveryChannelsChange: setCustomDeliveryChannelsValue, smsChannelEnabled: smsChannelEnabled, showDetails: showDetails, onShowDetails: setShowDetails, showNoSmsModal: showNoSmsModal, onShowNoSmsModal: setShowNoSmsModal, isLoadingCounts: isLoading, clients: clients }));
};
